import { useEffect, useState } from "react";

// import { getUserVideos } from "@/lib/api/api";
//import { getUser } from "@/lib/api/authentication";
import { VideoOverview } from "./video/overview";
import { UploadVideo } from "./video/upload";
// import { useAuthContext } from "../../providers/auth_provider";
// import { isAdmin } from "../../api/authentication";
import { YoutubeIcon } from "lucide-react";
import { Button } from "../ui/button";
import { isAdmin, isMember } from "@/lib/api/client-authentication";

// function UploadVideo(...args: any) {
// 	return (<><h1>Upload Video</h1></>)
// }

type Video = {
	id: string;

	location: string;
	tags: string[];
	thumbnail: string;
	title: string;
	type: string;
	user: string;
	watchCount: number;
	featured: boolean;
	Status: string;

	preview: string;
};

type Props = {
	userId: string;
	tier: string;
	isMember: boolean;
	isAdmin: boolean;
};

export const ManageVideos = ({ userId, tier, isMember, isAdmin }: Props) => {
	const [videos, setVideos] = useState<Video[] | { id: string }[]>([
		{ id: "" },
	]);
	const [upload, setUpload] = useState(false);
	const [edit, setEdit] = useState(false);
	const [editId, setEditId] = useState("");

	const [isViewer, setIsViewer] = useState(isMember || isAdmin ? false : true);

	useEffect(() => {
		fetch(`/api/user/video?id=${userId}`)
			.then((res) => res.json())
			.then((response) => {
				if (isViewer) {
					setVideos(response.filter((v: any) => v.Status == "ACTIVE"));
				} else {
					setVideos(response);
				}
			});
	}, []);

	const activateEdit = (videoId: string) => {
		setEdit(true);
		setEditId(videoId);
	};
	const activateUpload = () => {
		setUpload(true);
	};
	const deactivateUpload = () => {
		setUpload(false);
		setEdit(false);
	};

	const YoutubeIntroductoryVideos = () => {
		return (
			<div className="flex flex-wrap gap-y-3 ">
				<a
					href="https://www.youtube.com/watch?v=E9LtjLBQ2UE&ab_channel=BazaarRoomdotcom"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 break-words bg-blue-200 mr-2 px-2 py-1 rounded-3xl flex flex-row items-center ">
					<YoutubeIcon className="mr-1"></YoutubeIcon>
					Example Video for Businesses
				</a>

				<a
					href="https://www.youtube.com/watch?v=wHiL7VmCzqU&ab_channel=StanfordOnline"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 break-words bg-blue-200 mr-2 px-2 py-1 rounded-3xl flex flex-row items-center ">
					<YoutubeIcon className="mr-1"></YoutubeIcon>
					Example Video for Skill Sellers
				</a>
				<a
					href="https://www.youtube.com/watch?v=_87QAVf58eY&ab_channel=BazaarRoomdotcom"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 break-words bg-blue-200 px-2 py-1 rounded-3xl flex flex-row items-center ">
					<YoutubeIcon className="mr-1"></YoutubeIcon>
					Example Video for Products
				</a>
			</div>
		);
	};

	const UploadLayout = () => {
		if (!videos?.length)
			return (
				<>
					<YoutubeIntroductoryVideos />
					<UploadVideo
						userId={userId}
						editMode={edit}
						videoId={editId}
						tier={tier}
						showCancel={false}
						setEdit={setEdit}
						setUpload={setUpload}></UploadVideo>
				</>
			);
		return (
			<>
				<YoutubeIntroductoryVideos />
				<UploadVideo
					userId={userId}
					tier={tier}
					editMode={edit}
					videoId={editId}
					showCancel={true}
					setEdit={setEdit}
					setUpload={setUpload}></UploadVideo>
			</>
		);
	};

	if ((!isViewer && !videos?.length) || upload || edit)
		return <UploadLayout />;
	console.log("IS VIewer ", isViewer);
	return (
		<>
			<YoutubeIntroductoryVideos />
			<br />
			<br />
			{!isViewer && videos?.length < 10 && (
				<div className="flex flex-row">
					<div className="">
						<Button
							className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
							onClick={activateUpload}>
							Upload Video
						</Button>
					</div>
				</div>
			)}
			<br />
			{videos?.map((video) => {
				return (
					<>
						{" "}
						<VideoOverview
							userId={userId}
							isViewer={isViewer}
							activateEdit={activateEdit}
							video={video}
							setVideos={setVideos}
							key={video.id}></VideoOverview>
						<br />
					</>
				);
			})}
		</>
	);
	return;
};
